import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { PaginationOptions } from 'src/app/core/models/pagination_options';


@Component({
  selector: 'app-filter-and-sort-action-buttons',
  templateUrl: './filter-and-sort-action-buttons.component.html',
  styleUrls: ['./filter-and-sort-action-buttons.component.scss'],
})
export class FilterAndSortActionButtonsComponent {
  public sortField!: CustomSelectOption;
  public sortDirection!: CustomSelectOption;
  public filterTrashed!: CustomSelectOption;

  @Input()
  public paginationOptions!: PaginationOptions;

  @Input()
  public sortColumns!: Array<string>;

  @Input()
  public showFilter: boolean = true;

  /**
   * Hide the Excel/CSV export controls in the offcanvas drawer. Used
   * on pages that own a dedicated export button outside this widget
   * (e.g. the adjustments index, where export sits in the type-filter
   * row alongside the period chips).
   */
  @Input()
  public hideExport: boolean = false;

  @Output()
  onExport = new EventEmitter<string>();

  public trashedNotTrashed: Array<CustomSelectOption> = [
    {
      name: 'Trashed',
      value: 'trashed',
    },
    {
      name: 'Not Trashed',
      value: 'not_trashed',
    },
  ];

  public sortDirections: Array<CustomSelectOption> = [
    {
      name: 'Asc',
      value: 'asc',
    },
    {
      name: 'Desc',
      value: 'desc',
    },
  ];

  @Output()
  filterToggled = new EventEmitter();

  @Output()
  sortChanged = new EventEmitter();

  formartName(col: string): string {
    return col
      .replace(/_/gi, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  toggleFilter() {
    this.filterToggled.emit();
  }

  changeSort() {
    this.sortChanged.emit(this.sortField.value);
  }

  getSortColumns() {
    return this.sortColumns.map((el) => {
      return { name: this.formartName(el), value: el };
    });
  }

  constructor(private offcanvasService: NgbOffcanvas) { }

  ngOnInit() {
    this.sortField = {
      value: this.paginationOptions.sort,
      name: this.formartName(this.paginationOptions.sort),
    };
    this.sortDirection = {
      value: this.paginationOptions.direction,
      name: this.formartName(this.paginationOptions.direction),
    };
    this.filterTrashed = {
      value: this.paginationOptions.filter,
      name: this.formartName(this.paginationOptions.filter),
    };
    this.sortColumns.push("date_created");
    this.sortColumns.push("date_updated");
  }

  export(type: string) {
    this.onExport.emit(type);
  }

  open(content: TemplateRef<any>) {
    this.offcanvasService.open(content, { position: 'end' });
  }
}
